<template>
<div>
	<div style="width: 100%; display:flex;">

		<div style="width:70%;">
			<select class="form-control" v-model="user" style="width:90%;">
				<option v-for="option in extraData" v-bind:value="option.value">{{ option.text }}</option>
			</select>
		</div>
		<div>
			<div class="btn btn-default" v-on:click="downloadContract()">Ladda ner</div>
		</div>

	</div>

</div>
</template>


<script>
    export default {
        props: {
	        type: {},
	        currentData: {},
	        extraData: {},
	        rule: {},
	        clinicId: {}
	    },

	    data ()
	    {
	    	return {
	    		user: null
	    	}
	    },

	    methods: {

	    	downloadContract: function() {

	    		if (!this.user) {
	    			alert('Du måste välja en person som ska underteckna avtalet');
	    			return
	    		}

	    		var self = this;

	    		window.open('/clinics/'+self.clinicId+'/download/'+self.type+'?signer_name='+this.user);

	    		bus.$emit('contract-downloaded', self.type, Math.random().toString(36).substring(7))

	    	}

	    },
	    watch: {





	    }

    }
</script>
